module.exports = __webpack_public_path__ + "media/my_images/vision/tanigawa-0c838028e9e4f1fa3daca57e9aa2eb60.jpg";